import React, { useState } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ font: [] }], // Font family
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // Headings
    ["bold", "italic", "underline", "strike"], // Bold, Italic, etc
    [{ color: [] }, { background: [] }], // Colors
    [{ script: "sub" }, { script: "super" }], // Sub/Super
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ], // Lists
    [{ align: [] }], // Align
    ["link", "image", "video"], // Links, Images, Video
    ["blockquote", "code-block"], // Blockquote & Code
    ["clean"], // Remove formatting
    ["table"], // Table (requires quill-table module)
  ],
  clipboard: {
    matchVisual: false,
  },
};

const formats = [
  "font",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
  "blockquote",
  "code-block",
  "table",
];

export default function RichTextEditor({ value, onChange }) {
  return (
    <div>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        className="bg-white rounded-lg"
      />
    </div>
  );
}
